import React, { useEffect, useMemo, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import SortableTh, { sortRows } from "@/components/SortableTh";

export default function AuditLog() {
    const [rows, setRows] = useState([]);
    const [error, setError] = useState("");
    const [q, setQ] = useState("");
    const [filterAction, setFilterAction] = useState("");
    const [sort, setSort] = useState({ field: "created_at", dir: "desc" });

    useEffect(() => {
        (async () => {
            try { const { data } = await api.get("/audit-logs?limit=200"); setRows(data); }
            catch (err) { setError(formatApiError(err)); }
        })();
    }, []);

    const actions = useMemo(() => Array.from(new Set(rows.map((r) => r.action))).sort(), [rows]);

    const filtered = useMemo(() => {
        const base = rows.filter((r) => {
            if (filterAction && r.action !== filterAction) return false;
            if (q) {
                const s = q.toLowerCase();
                const blob = `${r.actor_email || ""} ${r.action} ${r.target_type || ""} ${r.target_id || ""} ${JSON.stringify(r.details || {})}`.toLowerCase();
                if (!blob.includes(s)) return false;
            }
            return true;
        });
        return sortRows(base, sort, { target: (r) => `${r.target_type || ""}:${r.target_id || ""}` });
    }, [rows, q, filterAction, sort]);

    return (
        <div data-testid="audit-page">
            <div className="page-head">
                <div>
                    <h1>Auditoría</h1>
                    <p>Registro append-only de acciones sensibles. Solo superadmin.</p>
                </div>
            </div>
            {error && <div className="alert alert-error">{error}</div>}
            <div className="card">
                <div className="card-header">
                    <h3>Últimos 200 eventos</h3>
                    <div className="tbar" style={{ display: "flex", gap: 8 }}>
                        <select className="select" value={filterAction} onChange={(e) => setFilterAction(e.target.value)} data-testid="audit-filter-action">
                            <option value="">Todas las acciones</option>
                            {actions.map((a) => <option key={a} value={a}>{a}</option>)}
                        </select>
                        <input className="input" style={{ width: 280 }} placeholder="Buscar por actor, target o detalles…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="audit-search" />
                    </div>
                </div>
                <div className="table-wrap">
                    <table className="t">
                        <thead>
                            <tr>
                                <SortableTh field="created_at" sort={sort} onChange={setSort}>Fecha</SortableTh>
                                <SortableTh field="actor_email" sort={sort} onChange={setSort}>Actor</SortableTh>
                                <SortableTh field="action" sort={sort} onChange={setSort}>Acción</SortableTh>
                                <SortableTh field="target" sort={sort} onChange={setSort}>Objetivo</SortableTh>
                                <th style={{ padding: "10px 12px", textAlign: "left", color: "#A3A3A8", fontSize: 11, textTransform: "uppercase", letterSpacing: ".06em", borderBottom: "1px solid #26262B" }}>Detalles</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.length === 0 && <tr><td colSpan={5} className="text-muted" style={{ textAlign: "center", padding: 30 }}>Sin registros.</td></tr>}
                            {filtered.map((r) => (
                                <tr key={r.log_id} data-testid={`audit-row-${r.log_id}`}>
                                    <td className="id-mono text-muted">{new Date(r.created_at).toLocaleString("es-MX")}</td>
                                    <td>{r.actor_email || "—"}</td>
                                    <td><span className="badge">{r.action}</span></td>
                                    <td className="text-muted mono" style={{ fontSize: 12 }}>{r.target_type ? `${r.target_type}:${r.target_id}` : "—"}</td>
                                    <td className="text-muted mono" style={{ fontSize: 11.5, maxWidth: 340, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{JSON.stringify(r.details || {})}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
